"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Radio = ({ checked, groupName, id, label, onChange, isLarge }) => {
    return (react_1.default.createElement("label", { htmlFor: id, className: (0, classnames_1.default)('znd-radio', 'd-flex', 'justify-content-between', 'align-items-center', {
            'znd-radio__large': isLarge,
        }) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('d-flex', 'align-items-center', 'custom-control', 'custom-radio') },
            react_1.default.createElement("input", { className: (0, classnames_1.default)('custom-control-input', 'znd-radio__input'), type: "radio", name: groupName, id: id, checked: !!checked, onChange: onChange }),
            react_1.default.createElement("span", { className: "znd-radio__label custom-control-label" }, label))));
};
exports.default = (0, mobx_react_1.observer)(Radio);
